import { createApp } from 'vue'
import App from './App.vue'
import { createPinia } from 'pinia'
import router from './router/router'
import apiClient from '@/services/apiClient'
import "bootstrap"



//Styles
import "bootstrap/dist/css/bootstrap.min.css"
import './assets/css/all.min.css'
import './assets/css/style.css'


const app = createApp(App);
const pinia = createPinia();

app.config.globalProperties.$axios = apiClient;
app.use(pinia)
app.use(router)

app.mount('#app')
